const messages = {
  title: "Interlocuteurs et numéros de service",
  subtitle: "Vos interlocuteurs personnels chez Bridgestone",
  description:
    "Nous sommes toujours là pour vous ! Trouvez ici votre interlocuteur Bridgestone personnel<br/>pour votre région ou adressez-vous tout simplement à nos collaboratrices et collaborateurs compétents<br/>du service clientèle.",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Équipe commerce pneus",
    car: "Équipe concession automobile",
    lkw: "Équipe poids lourds",
    em_otr: "Équipe EM/OTR",
    farm_tractor: "Équipe tracteurs agricoles",
    bandag: "Équipe Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "CONTACT ET SERVICE",
      description:
        "De l'utilisation de Bridgestone Plus au suivi de vos commandes, nos équipes vous accompagnent à chaque étape. Retrouvez ci-dessous les interlocuteurs dédiés à chacune de vos demandes.",
    },
    categories: {
      service: {
        description: "Numéro de service pour votre région et contact e-mail",
      },
      touch: {
        title: "",
        short_desc: "",
        description: "",
      },
      bridgestone: {
        title: "ASSISTANCE BRIDGESTONE PLUS",
        short_desc:
          "Une question liée à <span class='text-danger'>l'utilisation de la plateforme Bridgestone Plus</span>? Nos équipes sont à votre disposition.",
        description:
          "Une question sur <b>Bridgestone Plus ou ses applications</b>? Notre équipe est à votre disposition à <b><a href='mailto:plus.fr&#64;bridgestone.eu'>plus.fr&#64;bridgestone.eu</a></b> ou au <b>04 84 49 29 00</b> <i>(lun.-ven., 9h-12h / 14h-17h)</i>.",
      },
      dekouple: {
        title: "ASSISTANCE BOUTIQUE",
        short_desc:
          "Pour toute question liée à votre <span class='text-danger'>commande de produits (hors articles Bridgestone ou commandes de pneus),</span> contactez votre interlocuteur dédié.",
        description:
          "<div>Une question relative à votre <b>commande dans la boutique Bridgestone</b> (hors articles Bridgestone ou commandes de pneus)?</div><div class='pt-3'>Veuillez contacter directement notre fournisseur: <b>Dekuple Coup de Poing – <a href='mailto:bridgestoneplus.fr&#64;coupdepoing.com'>bridgestoneplus.fr&#64;coupdepoing.com</a> – 0 820 366 230</b> <i>(du lundi au vendredi, de 9h à 13h et de 14h à 18h).</i></div>",
      },
      premium_partner: {
        title: "ASSISTANCE BOUTIQUE BRIDGESTONE",
        titlePage:
          "ASSISTANCE BOUTIQUE <span class='text-danger'>BRIDGESTONE</span> et <span class='text-danger'>FIRESTONE</span>",
        short_desc:
          "Pour toute question liée à votre <span class='text-danger'>commande de produits Bridgestone ou Firestone</span> contactez votre service client dédié.",
        description:
          "<div>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Une question relative à votre</strong> <strong>commande dans la boutique Bridgestone</strong> <strong>?</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Veuillez contacter directement l'équipe support par email uniquement :</strong> <a href='mailto:collection.support.ext&#64;bridgestone.eu' style='text-decoration:none;'><strong><u><span style='color:#467886;'>collection.support.ext&#64;bridgestone.eu</span></u></strong></a></p>" +
          "</div>",
        content:
          "<div>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Vous pouvez également consulter nos FAQs ci-dessous :</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Expédition &amp; retours</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Délais de livraison</strong> en France : 3 à 5 jours ouvrables</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Frais de livraison</strong> : les frais de livraison sont inclus dans le prix unitaire des produits.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Toutes les commandes sont expédiées avec assurance et un numéro de suivi est communiqué.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Foire aux questions</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Puis-je modifier ma commande une fois validée et payée ?</strong><br>Non, le système étant entièrement automatisé, il n'est pas possible de modifier une commande après validation de celle-ci.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Comment puis-je suivre ma livraison ?</strong><br>Dès l'expédition de votre commande, vous recevrez un e-mail de notre partenaire logistique contenant un lien de suivi.<br>Si vous n'avez pas reçu cet e-mail, vous pouvez contacter notre équipe support par e-mail.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>J'ai reçu mon colis, mais ma commande était incomplète.</strong><br>Veuillez contacter notre équipe support. En collaboration avec notre service logistique, nous analyserons le processus d'expédition.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>J'ai reçu mon colis, mais certains articles sont endommagés.</strong><br>Veuillez contacter notre équipe support dans les 7 jours ouvrables suivant la réception de la livraison.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Procédure de retour</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Les retours de produits ne sont acceptés qu'en cas de dommage ou d'erreur de préparation de commande.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Puis-je retourner les produits commandés ?</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>En cas de dommage ou d'erreur de préparation de la commande, les marchandises peuvent être retournées. Elles ne sont acceptées que si les conditions suivantes sont remplies :<br>• Les produits sont dans leur état d'origine<br>• Les produits sont dans leur emballage d'origine<br>• Les produits n'ont pas été utilisés<br>• Le formulaire de retour est dûment rempli et joint au colis</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Après renvoi de vos produits, veuillez écrire à <a href='mailto:plus.fr&#64;bridgestone.eu' style='text-decoration:none;'><u><span style='color:#467886;'>plus.fr&#64;bridgestone.eu</span></u></a> pour demander d'être recrédité de vos points.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Comment effectuer un retour ?</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>ÉTAPE 1 : Contactez notre équipe support<br>ÉTAPE 2 : Après examen de votre demande, notre centre de support vous fournira un formulaire de retour<br>ÉTAPE 3 : Remplissez le formulaire de retour et joignez une copie papier du formulaire à votre envoi<br>ÉTAPE 4 : Envoyez le formulaire numérique à notre équipe support</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><br><strong>Qui prend en charge les frais de transport en cas de retour ?</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Les frais directs de retour des marchandises seront à votre charge, sauf en cas de dommages survenus lors du transport.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><br><strong>Adresse de retour</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Distrimedia<br>Meulebeeksesteenweg 20<br>8700 Tielt<br>Belgique</p>" +
          "</div>",
      },

      contact: {
        short_desc: "",
      },
    },

    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
